const primaryColor = '#FE9373';
const secondaryColor = '#FF6683';

const surfaceBottom = `linear-gradient(${ secondaryColor }, ${ primaryColor })`;
const surfaceBottomInverted = '#FFFFFF';
const surfaceFront = '#FFFFFF';
const surfaceTop = '#FF6683';
const primaryText = '#FFFFFF';
const primaryTextInverted = '#ff6981';
const safeText = 'rgb(77, 77, 77)';

/*Modal stuff*/
const modalBackground = '#FFFFFF';
const modalPrimaryText = primaryTextInverted;
const modalPrimaryColor = primaryColor;
const modalPrimaryColorInverted = '#FFFFFF';

export default {
	colors: {
		surfaceBottom,
		surfaceBottomInverted,
		surfaceFront,
		surfaceTop,
		primaryText,
		primaryTextInverted,
		safeText,
		primaryColor,
		secondaryColor,
		/*Modal*/
		modalBackground,
		modalPrimaryText,
		modalPrimaryColor,
		modalPrimaryColorInverted,
		/*General*/
		defaultBoxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12);',
		mask: 'rgba(0,0,0,0.3)',
		desktopBackground: 'rgba(255, 102, 131, 0.5)',
	},
	properties: {
		darkLogo: false,
		outlinedPrimary: true
	}
}
